import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import ThemeContext from '../contexts/ThemeContext';
import InterpreterNow from './InterpreterNow';
import i18n from '../i18n';
import withLeftSideBar from '../hocs/withLeftSideBar';
import { MainHeader, MainContentTopBar } from '../components/basicComponents';

const StyledAiHomeContainer = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
`;

const StyledCard = styled.div`
  background: #fff;
  border-radius: 15px;
  box-shadow: 0 4px 32px 0 rgba(31, 31, 63, 0.10);
  padding: 32px 24px 24px 24px;
  width: 100%;
  max-width: 660px;
  height: 100%;
  max-height: 750px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
`;

const CenteredWrapper = styled.div`
  width: 100%;
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: flex-start;
  padding: 10px 10px;
`;

const AiHome = (props) => {
  const { colors, layout } = useContext(ThemeContext);
  const location = useLocation();

  return (
    <StyledAiHomeContainer {...props}>
      <MainContentTopBar
        borderBottomColor={colors.webDeviderColor}
      >
        <MainHeader
          padding={layout.padding}
          color={colors.webDarkBlue}
      >
          {i18n('od_type_ai_subtitle')}
        </MainHeader>
      </MainContentTopBar>
      <CenteredWrapper>
        <StyledCard>
          <InterpreterNow
            isAiMeetingClosed={location?.state?.aiMeetingClosed}
            aiChatroomId={location?.state?.chatroomId}
            closeModal={() => {}}
          />
        </StyledCard>
      </CenteredWrapper>
    </StyledAiHomeContainer>
  );
};

export default withLeftSideBar(AiHome); 